export default __webpack_public_path__ + "static/media/slide1.2388dcaa.png";